module.exports = __webpack_public_path__ + "img/Weapon_76.28d97118.png";